import React from "react";
import Login from "../components/Login";
import Footer from "../components/UI/Footer";

export default function Auth() {
    return (
        <div className="full-view">
            <Login />
            <Footer />
        </div>
    );
}
